import { Outlet } from 'react-router';

import InitGuard from 'utils/route-guard/InitGuard';

export default function InitLayout() {
  return (
    <InitGuard>
      <Outlet />
    </InitGuard>
  );
}
